/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import * as API from "../../http/api";
import { REGEX_EMAIL } from "../../util/RegEx";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem, Checkbox, FormControlLabel } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { closelightbox } from '../../util/Functions';
import { useHistory } from 'react-router-dom';
import { Close, FileDownload, KeyboardArrowDown, DateRange } from "@mui/icons-material";
import MonthPicker from "@9softstudio/react-monthpicker";
import "@9softstudio/react-monthpicker/dist/reactmonthpicker.css";
import moment from "moment";
import "moment/locale/es";

const AccountStatement = (props) => {
  moment.locale("es");
  const [spaceUuid, setSpaceUuid] = useState("");
  const [zPos, setZPos] = useState(45)

  const [max, setMax] = useState("");
  const [initMaxMonth, setInitMaxMonth] = useState(1);
  const [initMaxYear, setInitMaxYear] = useState(new Date().getFullYear());
  const [endMinMonth, setEndMinMonth] = useState(initMaxMonth);
  const [endMaxMonth, setEndMaxMonth] = useState(initMaxMonth);
  const [endMinYear, setEndMinYear] = useState(initMaxYear);
  const [endMaxYear, setEndMaxYear] = useState(initMaxYear);
  const [selectedYear, setSelectedYear] = useState(initMaxYear);

  const [yearMonthIni, setYearMonthIni] = useState("");
  const [yearMonthFin, setYearMonthFin] = useState("");
  const [last, setLast] = useState(false);
  const history = useHistory();

  const [roles, setRoles] = useState([]);
  const [active, setActive] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [errorMail, setErrorsMail] = useState("");
  const [errorDate, setErrorsDate] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [spaceCancel, setSpaceCancel] = useState<any>(null);

  useEffect(() => {
    if (localStorage.session) {
      let rol = localStorage.config && JSON.parse(localStorage.config)['idRol'] ? [JSON.parse(localStorage.config)['idRol']] : [];
      setRoles(rol);
    }
    setDisabled(false);
    if (props.spaces) {
      setSpaceUuid(props.spaces[0].uuid);
      init(props.spaces[0].appUUID);
    }
  }, []);

  // Al entrar (y al cambiar de cuenta) consultamos indigo_space_cancel por space_uuid
  // para saber desde cuándo está inactiva la cuenta seleccionada.
  useEffect(() => {
    let ignore = false;
    const fetchSpaceCancel = async () => {
      if (!spaceUuid) {
        setSpaceCancel(null);
        return;
      }
      try {
        const resp = await API.service("spaceCancelGet", { space_uuid: spaceUuid }, props.pos, props.changeAlert, props.changeLoader, history);
        if (!ignore) {
          setSpaceCancel(resp?.data?.data?.content || null);
        }
      } catch (e) {
        if (!ignore) {
          setSpaceCancel(null);
        }
      }
    };
    fetchSpaceCancel();
    return () => { ignore = true; };
  }, [spaceUuid]);

  const init = (appUUID) => {
    let day = new Date();
    let today = moment(day).format("l");
    let m = Number(today.split("/")[1]);
    let y = Number(today.split("/")[2]);

    if(appUUID === "3" || appUUID === "4"){
      y = m === 1 ? y - 1 : y;
      m = m === 1 ? 12 : m - 1;
    } else {
      if (day.getDate() < 10) {
        if (m <= 2) {
          y = y - 1;
          m = m == 1 ? 11 : 12;
        } else {
          m = m - 2;
        }
      } else {
        y = m === 1 ? y - 1 : y;
        m = m === 1 ? 12 : m - 1;
      }
    }

    setInitMaxMonth(m);
    setInitMaxYear(y);
    setEndMaxMonth(m);
    setEndMaxYear(y);
    setEndMinMonth(m);
    setEndMinYear(y);
    setSelectedYear(y);
    const max = y + "-" + (m < 10 ? "0" + m : m);
    setMax(max);
    setYearMonthIni(max);
    setYearMonthFin(max);
  }

  const defaultProps = {
    monthNames: [
      ["Ene", "Feb", "Mar"],
      ["Abr", "May", "Jun"],
      ["Jul", "Ago", "Sep"],
      ["Oct", "Nov", "Dic"],
    ],
  };

  const dateFormat = (m, y) => {
    let month = 0;
    if (m > 0) {
      month = m - 1;
    }
    let f = new Date(y, month, 1);
    let fecha = moment(f).format("MMMM YYYY");
    return fecha.charAt(0).toUpperCase() + fecha.slice(1);
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLast(event.target.checked);
  };
  const handleEmail = (e) => {
    if (active && !REGEX_EMAIL.test(e.target.value)) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
    setNewEmail(e.target.value);
  };

  const changeMonthIni = (month, year) => {
    setEndMinMonth(month);
    setEndMinYear(year);
    const yearMonthIni = year + "-" + (month < 10 ? "0" + month : month);
    setYearMonthIni(yearMonthIni);
    setSelectedYear(year);
    changeMonthFin(month, year);
  };

  const changeMonthFin = (month, year) => {
    const yearMonthFin = year + "-" + (month < 10 ? "0" + month : month);
    setYearMonthFin(yearMonthFin);
  };

  const diffMonth = (d1, d2) => {
    let months = 0;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  };

  const createDates = (ini, fin) => {
    const startOfMonth = moment(ini).clone().startOf('month').set('hours', 6).format().substring(0, 19) + '.000+00:00';
    const endOfMonth = moment(fin).clone().endOf('month').set('hours', 4).format().substring(0, 19) + '.000+00:00';
    let dates = [[startOfMonth, endOfMonth]];
    return dates;
  };

  const send = async (download) => {
    if (!active) {
      setDisabled(false);
    }
    if (!spaceUuid) {
      return;
    }
    let ini = yearMonthIni;
    let fin = yearMonthFin;
    if (last) {
      ini = max;
      fin = max;
    }

    let s = createDates(ini, fin);
    props.changeLoader(true);
    setZPos(-1)
   
    let data = {
      uuid: spaceUuid,
      dates: s,
    };
    let auth = await API.auth(props.pos);
    if (auth.status != 200) {
      delete localStorage.session;
      history.push("/login");
    } else {
      let info = JSON.parse(localStorage.session);
      info["token"] = auth.data.token;
      localStorage.session = JSON.stringify(info);
    }

    if (download) {
      setActive(false);
      delete data["newEmail"];
      data["downloadFile"] = true;
      data["customerEmail"]= props.dataCustomer.email;
    }
    if (active && newEmail && !download) {
      data["newEmail"] = newEmail;
      data["name"] = props.dataCustomer.name;
    }
    if (active && ini.split("-")[1] !== fin.split("-")[1]) {
      setErrorsDate("Sólo puedes seleccionar un mes");
      props.changeLoader(false);
      setZPos(45)
      return;
    } else {
      setErrorsDate("");
    }
    if (active && !newEmail && !download) {
      data["customerEmail"]= props.dataCustomer.email;
      setErrorsMail("Campo Requerido");
      props.changeLoader(false);
      setZPos(45)
      return;
    } else {
      data["customerEmail"] = props.dataCustomer.email;
      setErrorsMail("");
    }

    if(props.spaces[0].appUUID === "3" || props.spaces[0].appUUID === "4"){
      data["afbStatement"] = true;
    }

    // Se agrega el nodo si NO existe registro de cancelación en indigo_space_cancel
    // o si existe y ya venció el plazo de 6 meses a mes vencido.
    // Ej.: cancelado el 15-abr, los 6 meses se cumplen el 15-oct, pero queda
    // disponible hasta el inicio del mes siguiente (1-nov).
    const cancelAvailableFrom = spaceCancel?.cdate
      ? moment(spaceCancel.cdate).add(6, "months").startOf("month").add(1, "month")
      : null;
    const canAddCancelled = !spaceCancel || (cancelAvailableFrom && moment().isSameOrAfter(cancelAvailableFrom));
    if ((props.dataCustomer.status == "Inactivo" || props.dataCustomer.status == "disabled") && hasAction("isCancelled") && canAddCancelled) {
      data["isCancelled"] = true;
      data["customer"] = { uuid: props.dataCustomer.uuid};
    }
    
    let request = await API.service( "estadoCuenta", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.data.data.response == "OK") {
      props.changeAlert( true, "success", request.data.data.message );
      closelightbox();
      props.changeLoader(false);
      // setZPos(45)
      return;
    } else {
      var message = request.data.data.message.detail
      props.changeAlert( true, "error", "Error: " + message );
    }
    props.changeLoader(false);
    setZPos(45)
  };

  const onSelectSpace = (event: React.ChangeEvent<{ value: unknown }>) => {
    let value = event.target.value as string;
    setSpaceUuid(value);
    let space = props.spaces?.filter(item => item.uuid === value)
    return init(space[0].appUUID);
  };

  const colapse = () => {
    if (active) {
      setDisabled(false);
      setActive(false);
    } else {
      setActive(true);
    }
  };

  const download = async () => {
    await send(true);
  };

  const hasAction = (action) => {
    return props.config?.actions?.indexOf(action) > -1;
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle>
          Estado de Cuenta
          { hasAction("download") && <IconButton id="secondButton" onClick={() => send(true)}><FileDownload/></IconButton>}
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent>
           <Grid container spacing={2} sx={{ marginTop: "10px", marginBottom: "18px" }}>
            <Grid item xs={6}>
              <TextField
                value={spaceUuid} onChange={onSelectSpace}	label="Cuenta" select	size="small" fullWidth >
                {props.spaces?.map((item, index) => (
                  <MenuItem key={index} value={item.uuid}>{item.accountNumber}</MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>

          <p style={{padding: "0px" }}>Selecciona un mes, un rango de meses o el último estado de cuenta disponible.</p >

          <Grid container spacing={2} sx={{ marginTop: "5px" }}>
            <Grid item xs={6}>
              <p style={{padding: "0px", paddingBottom: "5px" }}>Mes inicial</p >
              <MonthPicker
                onSelect={changeMonthIni.bind(this)}
                monthNames={defaultProps.monthNames}
                hasRange={true}
                onFormat={dateFormat}
                isReadonly={true}
                minMonth={10}
                minYear={2016}
                maxMonth={initMaxMonth}
                maxYear={initMaxYear}
                selectedMonth={initMaxMonth}
                selectedDropdownYear={initMaxYear}
                enable={!last}
                iconElement={
                  <IconButton style={{position: "absolute", right: "0", top: "0"}}><DateRange fontSize="small" /></IconButton>
                }
              />
            </Grid>
            <Grid item xs={6}>
              <p style={{padding: "0px", paddingBottom: "5px" }}>Mes final</p >
              <MonthPicker
                onSelect={changeMonthFin.bind(this)}
                monthNames={defaultProps.monthNames}
                hasRange={true}
                onFormat={dateFormat}
                isReadonly={true}
                minMonth={endMinMonth}
                minYear={endMinYear}
                maxMonth={endMaxMonth}
                maxYear={endMaxYear}
                enable={!last}
                selectedDropdownYear={selectedYear}
                selectedMonth={endMinMonth}
                iconElement={
                  <IconButton style={{position: "absolute", right: "0", top: "0"}}><DateRange fontSize="small" /></IconButton>
                }
              />
              {errorDate && (
                <label className="errorFieldMessage" style={{ color: "red" }}>
                  {errorDate}
                </label>
              )}
            </Grid>
          </Grid>       
            
          <Grid item xs={12} sx={{ marginTop: "16px" }}>
            <FormControlLabel control={<Checkbox checked={last} onChange={handleChange}/>} label={"Último estado de cuenta"} />
          </Grid>
          <Grid item xs={12} sx={{ marginTop: "20px" }}>      
            Ingresar nuevo email  <IconButton onClick={colapse.bind(this, false)}><KeyboardArrowDown /></IconButton>
          </Grid>

          {active && <Grid container spacing={2} sx={{ marginTop: "0px", marginBottom: "18px" }}>
            <Grid item xs={6}>
              <TextField
                onChange={handleEmail.bind(this)}	label="Email" size="small" fullWidth error={errorMail !== ""} helperText={errorMail ? errorMail : ''} >
              </TextField>
            </Grid>
          </Grid>}

          <p style={{padding: "0px", marginTop: "20px" }}> Se enviará a {active ? newEmail : props.dataCustomer.email},{" "}{props.dataCustomer.name}</p >
        </DialogContent>

        <DialogActions>    
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
          <Button disabled={disabled} variant="contained" onClick={send.bind(this, false)} >Enviar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog> 
  );
};

export default AccountStatement;
